import { defineStore } from 'pinia'
import { ISnackbar } from '@src/types/snackbar.types'
import _first from 'lodash/first'
import { computed, ref } from 'vue'

const SNACKBAR_MAX_VISIBILITY_DURATION = 5000
const SNACKBAR_MIN_VISIBILITY_DURATION = 1000
const timeoutRefs: ReturnType<typeof setTimeout>[] = [] // this is kept outside of serializable state

export const useSnackbarStore = defineStore('snackbar', () => {
  const snackbarQueue = ref<ISnackbar[]>([])

  const isSnackbarVisible = computed(() => !!_first(snackbarQueue.value))
  const snackbar = computed(() => _first(snackbarQueue.value))

  function show(sb: string | ISnackbar) {
    const newSnackbar = typeof sb === 'string' ? { translationKey: sb } : sb
    pushSnackbar(newSnackbar)

    function hideLatestSnackbar() {
      hideLatestSnackbarAction()
      timeoutRefs.shift()
    }

    // Clear the timeouts for each snackbar in the queue and set a new timeout
    timeoutRefs.forEach((tRef, index) => {
      clearTimeout(tRef)
      timeoutRefs[index] = setTimeout(hideLatestSnackbar, SNACKBAR_MIN_VISIBILITY_DURATION * (index + 1))
    })

    // The timeout for the most recent snackbar is 5000 + 1000 for each of the previous snackbars
    timeoutRefs.push(setTimeout(hideLatestSnackbar, SNACKBAR_MIN_VISIBILITY_DURATION * timeoutRefs.length + SNACKBAR_MAX_VISIBILITY_DURATION))
  }

  const pushSnackbar = (sb: ISnackbar) => {
    snackbarQueue.value = snackbarQueue.value.concat(sb)
  }

  const hideLatestSnackbarAction = () => {
    snackbarQueue.value = snackbarQueue.value.slice(1)
  }

  return {
    isSnackbarVisible,
    snackbarQueue,
    snackbar,
    show,
    hideLatestSnackbar: hideLatestSnackbarAction
  }
})
